
import Button from '@/ui-kit/components/button';
import { ButtonType } from '@/ui-kit/components/button/enums';
import { StyleColorSchemeType, StyleSizeType } from '@/ui-kit/styles/enums';
import NameInput from '@/components/inputs/name';
import EmailInput from '@/components/inputs/email';

export default {
  name: 'ShareListingModalForm',
  components: {
    Button,
  },
  props: {
    isLoading: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      StyleColorSchemeType,
      StyleSizeType,
      ButtonType,
      form: {
        name: {
          value: '',
          error: null,
          component: NameInput,
        },
        email: {
          value: '',
          error: null,
          component: EmailInput,
        },
      },
    };
  },
  computed: {
    hasErrors() {
      return Object.values(this.form).some(({ error, value }) => error || !value);
    },
    fromValue() {
      return Object.fromEntries(
        Object.entries(this.form).map(([controlName, { value }]) => ([controlName, value])),
      );
    },
  },
  methods: {
    handleControlChange(controlName, controlValue) {
      this.form[controlName].value = controlValue;
    },
    handleControlErrorChange(controlName, { errorMessage }) {
      this.form[controlName].error = errorMessage;
    },
    handleSubmit() {
      this.$emit('submit', this.fromValue);
    },
  },
};
